// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  width: 100%;
  display: flex;
  gap: 24px;
  height: calc(100vh - 165px);
}

/* Filters Section */
.filters-section {
  width: 280px;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(27, 40, 94, 0.08);
  overflow: hidden;
  height: calc(100vh - 100px) !important;
}

.filters-title {
  color: #1B285E;
  font-family: "Trasandina", sans-serif;
  font-size: 1rem;
  font-weight: 500;
  padding: 16px;
  border-bottom: 1px solid rgba(27, 40, 94, 0.08);
  background: white;
  flex-shrink: 0;
}

.filter-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 16px;
  background: white;
  border-bottom: 1px solid rgba(27, 40, 94, 0.08);
  flex-shrink: 0;
}

.filter-chip {
  background: rgba(27, 40, 94, 0.05) !important;
  color: #1B285E !important;
  font-size: 0.813rem !important;
  height: 28px !important;
  border-radius: 14px !important;
}

.filter-chip .MuiChip-deleteIcon {
  color: #1B285E !important;
  font-size: 16px !important;
  opacity: 0.5;
}

.filter-chip .MuiChip-deleteIcon:hover {
  opacity: 1;
}

.filter-section {
  padding: 16px;
  position: relative;
  border-bottom: 1px solid transparent;
}

.filter-section.has-selected {
  border-bottom: 1px solid rgba(27, 40, 94, 0.08);
}

.filter-section.has-selected::before {
  content: '';
  position: absolute;
  left: 0;
  top: 16px;
  bottom: 16px;
  width: 3px;
  background: #1B285E;
  border-radius: 0 2px 2px 0;
}

.filter-label {
  color: #1B285E;
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.filter-options {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.filter-option {
  background: transparent !important;
  border: none !important;
  color: rgba(27, 40, 94, 0.7) !important;
  padding: 4px 8px !important;
  margin-left: -8px !important;
  border-radius: 0 !important;
  font-size: 0.875rem !important;
  min-width: unset !important;
  text-transform: none !important;
  transition: all 0.2s ease !important;
  text-align: left !important;
  justify-content: flex-start !important;
  position: relative !important;
  width: fit-content !important;
}

.filter-option::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 8px;
  right: 8px;
  height: 2px;
  background-color: #1B285E;
  transform: scaleX(0);
  transition: transform 0.2s ease;
}

.filter-option:hover {
  background: rgba(27, 40, 94, 0.03) !important;
  color: #1B285E !important;
}

.filter-option:hover::after {
  transform: scaleX(0.3);
}

.filter-option.selected {
  background: transparent !important;
  color: #1B285E !important;
  font-weight: 600 !important;
}

.filter-option.selected::after {
  transform: scaleX(1);
}

.filter-switch {
  margin: 0 !important;
}

.filter-input {
  width: 100% !important;
}

.filter-input .MuiOutlinedInput-root {
  border-radius: 4px !important;
}

/* Content Section */
.content-section {
  flex: 1 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(27, 40, 94, 0.08);
  overflow: hidden;
}

.content-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0;
  flex-shrink: 0;
  padding: 16px;
  border-bottom: 1px solid rgba(27, 40, 94, 0.08);
  background: white;
  position: sticky;
  top: 0;
  z-index: 2;
}

.dashboard-title {
  color: #1B285E;
  font-family: "Trasandina", sans-serif;
  font-size: 1.25rem;
  margin: 0;
}

.results-count {
  color: rgba(27, 40, 94, 0.7);
  font-size: 0.875rem;
}

.export-buttons {
  display: flex;
  gap: 8px;
}

/* Scrollable container for both filters and table */
.scrollable-content {
  flex: 1 1;
  overflow: auto;
  min-height: 0;
  position: relative;
  overflow-x: auto !important;
  overflow-y: auto !important;
  height: calc(100vh - 200px) !important;
}

/* Table Styles */
.dashboard-table-container {
  width: 100%;
  height: 100%;
  position: relative;
}

.dashboard-table {
  width: 100%;
}

.table-header-row {
  position: sticky !important;
  top: 0 !important;
  z-index: 1 !important;
  background: white !important;
}

.dashboard-table-header {
  padding: 6px 8px !important;
  font-size: 0.8rem !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  background-color: #1B285E !important;
  color: white !important;
  position: sticky !important;
  top: 0 !important;
  z-index: 2 !important;
}

/* Fixed height for table rows */
.table-row {
  height: 48px !important; /* Fixed height for all rows */
}

.dashboard-table-cell {
  padding: 6px 8px !important;
  font-size: 0.8rem !important;
  white-space: nowrap !important;
  text-overflow: ellipsis !important;
  overflow: hidden !important;
  max-width: 150px !important;
  color: #1B285E !important;
  border-bottom: 1px solid rgba(27, 40, 94, 0.05) !important;
  background: white !important;
  transition: opacity 0.3s ease !important;
  line-height: 1.2 !important; /* Consistent line height */
  height: 48px !important; /* Match the row height */
  box-sizing: border-box !important;
}

.table-row:hover .dashboard-table-cell {
  background-color: rgba(27, 40, 94, 0.02) !important;
}

.table-loading {
  position: relative;
}

.table-loading::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.7);
  z-index: 2;
  pointer-events: none;
}

.table-loading-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
}

/* Custom scrollbar */
.scrollable-content::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.scrollable-content::-webkit-scrollbar-track {
  background: transparent;
}

.scrollable-content::-webkit-scrollbar-thumb {
  background: rgba(27, 40, 94, 0.2);
  border-radius: 4px;
}

.scrollable-content::-webkit-scrollbar-thumb:hover {
  background: rgba(27, 40, 94, 0.3);
}

/* Pagination */
.MuiTablePagination-root {
  flex-shrink: 0;
  border-top: 1px solid rgba(27, 40, 94, 0.08);
  background: white;
}

/* Responsive Design */
@media (max-width: 960px) {
  .dashboard-container {
    flex-direction: column;
    height: auto;
    gap: 16px;
  }

  .filters-section {
    width: 100%;
    min-width: 0;
  }

  .filter-options {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 8px;
  }

  .filter-option {
    padding: 4px 12px !important;
    background: rgba(27, 40, 94, 0.05) !important;
    border-radius: 16px !important;
  }

  .content-section {
    height: calc(100vh - 400px);
  }
}

@media (max-width: 600px) {
  .content-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .export-buttons {
    width: 100%;
  }

  .export-buttons button {
    flex: 1 1;
  }
}

/* Estilos para los iconos de paginación */
.MuiTablePagination-actions {
  color: #1B285E !important; /* Usa el mismo color azul que el resto de la UI */
}

.MuiTablePagination-actions button {
  color: rgba(27, 40, 94, 0.7) !important; /* Color más suave para los botones */
}

.MuiTablePagination-actions button:hover {
  color: #1B285E !important; /* Color más oscuro al hover */
}

.MuiTablePagination-actions button.Mui-disabled {
  color: rgba(27, 40, 94, 0.3) !important; /* Color más claro para botones deshabilitados */
}

/* Estilos para el modo edición */
.actions-cell {
  width: 100px;
  text-align: right !important;
}

.edit-button {
  opacity: 0;
  transition: opacity 0.2s ease;
}

.table-row:hover .edit-button {
  opacity: 1;
}

/* Estilos para los campos de edición */
.dashboard-table-cell .MuiTextField-root {
  margin: -8px 0;
}

.dashboard-table-cell .MuiCheckbox-root {
  margin: -12px;
}

/* Apollo processed row styling */
.apollo-processed-row.table-row {
  background-color: rgba(144, 202, 249, 0.15) !important;
}

.apollo-processed-row.table-row:hover {
  background-color: rgba(144, 202, 249, 0.25) !important;
}

/* Add a CSS class for the profile photo column */
.profile-photo-cell {
  width: 40px !important;
  padding: 4px !important;
}

/* Make the table container take full width */
.MuiTableContainer-root {
  width: 100% !important;
}

/* Add responsive styling for smaller screens */
@media (max-width: 1200px) {
  .dashboard-table-header, 
  .dashboard-table-cell {
    padding: 4px 6px !important;
    font-size: 0.75rem !important;
  }
}

/* Add styles for email status chips */
.email-status-chip.verified {
  background-color: rgba(46, 125, 50, 0.1) !important;
  color: #2e7d32 !important;
  border-color: #2e7d32 !important;
}

.email-status-chip.extrapolated {
  background-color: rgba(237, 108, 2, 0.1) !important;
  color: #ed6c02 !important;
  border-color: #ed6c02 !important;
}

.email-status-chip.unavailable {
  background-color: rgba(211, 47, 47, 0.1) !important;
  color: #d32f2f !important;
  border-color: #d32f2f !important;
}

/* Style for the employment history tooltip */
.employment-history-tooltip {
  max-width: 500px !important;
  font-size: 0.8rem !important;
}

/* Enhanced employment history tooltip styles */
.employment-history-tooltip,
.MuiTooltip-tooltip .employment-history-tooltip {
  max-width: 500px !important;
  font-size: 0.9rem !important;
  line-height: 1.5 !important;
  padding: 12px !important;
  background-color: #fff !important;
  color: #000 !important;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;
  border-radius: 8px !important;
  border: 1px solid rgba(27, 40, 94, 0.1) !important;
}

.employment-history-tooltip strong {
  color: #1B285E !important;
  font-weight: 600 !important;
}

/* Style for the LinkedIn button */
.linkedin-button {
  min-width: unset !important;
  padding: 2px 8px !important;
}

/* Add styles for the employment history stepper */
.MuiStepper-root {
  padding: 0 !important;
}

.MuiStepContent-root {
  margin-left: 12px !important;
  padding-left: 20px !important;
  border-left: 1px solid rgba(27, 40, 94, 0.2) !important;
}

.MuiStepLabel-root {
  padding: 0 !important;
}

.MuiStepLabel-labelContainer {
  color: #1B285E !important;
}

.MuiStepConnector-line {
  min-height: 24px !important;
  border-left-width: 2px !important;
  border-left-style: solid !important;
  border-color: rgba(27, 40, 94, 0.2) !important;
}

/* Enhanced styles for employment history */
.employment-history .MuiTypography-subtitle1 {
  font-size: 1rem !important;
  font-weight: 600 !important;
  color: #1B285E !important;
}

.employment-history .MuiTypography-body2 {
  font-size: 0.9rem !important;
  color: #000 !important;
  line-height: 1.5 !important;
  margin-bottom: 6px !important;
}

.employment-history .MuiStepContent-root {
  background-color: rgba(255, 255, 255, 0.8) !important;
  border-left: 2px solid rgba(27, 40, 94, 0.3) !important;
  padding: 8px 16px !important;
  margin-bottom: 12px !important;
  border-radius: 0 0 4px 4px !important;
}

.employment-history .MuiAvatar-root {
  border: 2px solid #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

/* Same enhanced styles for education history */
.education-history .MuiTypography-subtitle1 {
  font-size: 1rem !important;
  font-weight: 600 !important;
  color: #1B285E !important;
}

.education-history .MuiTypography-body2 {
  font-size: 0.9rem !important;
  color: #000 !important;
  line-height: 1.5 !important;
  margin-bottom: 6px !important;
}

.education-history .MuiStepContent-root {
  background-color: rgba(255, 255, 255, 0.8) !important;
  border-left: 2px solid rgba(63, 81, 181, 0.3) !important;
  padding: 8px 16px !important;
  margin-bottom: 12px !important;
  border-radius: 0 0 4px 4px !important;
}

.education-history .MuiAvatar-root {
  border: 2px solid #fff !important;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;
}

/* Custom styles for current job indicator */
.current-job-chip {
  background-color: rgba(27, 40, 94, 0.1) !important;
  color: #1B285E !important;
  font-weight: 500 !important;
}

/* Add styles for Apollo processed indicators */
.apollo-data-section {
  margin-bottom: 24px;
  padding: 16px;
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
}

.apollo-data-section h3 {
  margin-top: 0;
  margin-bottom: 16px;
  color: #1B285E;
  font-weight: 600;
  font-size: 1.2rem;
  border-bottom: 2px solid rgba(27, 40, 94, 0.1);
  padding-bottom: 8px;
}

.apollo-data-section .MuiListItem-root {
  border-radius: 4px;
  transition: background-color 0.2s ease;
}

.apollo-data-section .MuiListItem-root:hover {
  background-color: rgba(144, 202, 249, 0.1);
}

.apollo-data-badge {
  position: absolute;
  top: -10px;
  right: 16px;
  background-color: rgba(25, 118, 210, 0.9);
  color: white;
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 4px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

/* Enhanced drawer styles for better readability */
.drawer-content {
  padding: 20px 16px;
  overflow-y: auto;
  height: 100%;
  background-color: #f9f9f9;
}

.drawer-header {
  background-color: #fff;
  border-radius: 8px;
  padding: 16px !important;
  margin-bottom: 24px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

/* Make list items more readable */
.drawer-content .MuiListItem-root {
  padding: 10px 0;
  margin-bottom: 4px;
}

.drawer-content .MuiListItemIcon-root {
  color: #1B285E;
  min-width: 36px !important;
}

.drawer-content .MuiListItemText-root .MuiTypography-root {
  font-size: 0.95rem;
  color: rgba(0, 0, 0, 0.87);
  font-weight: 500;
}

.drawer-content strong {
  font-weight: 600;
  color: #1B285E;
}

.drawer-content a {
  color: #1976d2;
  text-decoration: none;
  font-weight: 500;
}

.drawer-content a:hover {
  text-decoration: underline;
  color: #1565c0;
}

/* Divider styling */
.drawer-content .MuiDivider-root {
  margin: 16px 0 !important;
  background-color: rgba(27, 40, 94, 0.1);
  height: 2px !important;
}

.dashboard-table-cell .MuiBox-root {
  display: flex !important;
  align-items: center !important;
  height: 100% !important;
}

/* Ensure icons are aligned properly */
.dashboard-table-cell .MuiSvgIcon-root {
  flex-shrink: 0 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,SAAS;EACT,2BAA2B;AAC7B;;AAEA,oBAAoB;AACpB;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,+CAA+C;EAC/C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;EACzB,8BAA8B;EAC9B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,oCAAoC;AACtC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,YAAY;EACZ,UAAU;EACV,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,uCAAuC;EACvC,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,2BAA2B;EAC3B,+BAA+B;EAC/B,oCAAoC;EACpC,2BAA2B;EAC3B,sCAAsC;EACtC,6BAA6B;EAC7B,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,6CAA6C;EAC7C,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,+CAA+C;EAC/C,iBAAiB;EACjB,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qCAAqC;EACrC,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA,oDAAoD;AACpD;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,2BAA2B;EAC3B,2BAA2B;EAC3B,sCAAsC;AACxC;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,oCAAoC;EACpC,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,uBAAuB,EAAE,8BAA8B;AACzD;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,2BAA2B;EAC3B,yBAAyB;EACzB,0DAA0D;EAC1D,4BAA4B;EAC5B,wCAAwC;EACxC,2BAA2B,EAAE,2BAA2B;EACxD,uBAAuB,EAAE,yBAAyB;EAClD,iCAAiC;AACnC;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,UAAU;AACZ;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA,eAAe;AACf;EACE,cAAc;EACd,4CAA4C;EAC5C,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,QAAQ;EACV;;EAEA;IACE,4BAA4B;IAC5B,6CAA6C;IAC7C,8BAA8B;EAChC;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;AACF;;AAEA,0CAA0C;AAC1C;EACE,yBAAyB,EAAE,kDAAkD;AAC/E;;AAEA;EACE,uCAAuC,EAAE,qCAAqC;AAChF;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,uCAAuC,EAAE,gDAAgD;AAC3F;;AAEA,iCAAiC;AACjC;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,UAAU;AACZ;;AAEA,uCAAuC;AACvC;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,sDAAsD;AACxD;;AAEA;EACE,sDAAsD;AACxD;;AAEA,iDAAiD;AACjD;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,6CAA6C;AAC7C;EACE,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE;;IAEE,2BAA2B;IAC3B,6BAA6B;EAC/B;AACF;;AAEA,sCAAsC;AACtC;EACE,mDAAmD;EACnD,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,mDAAmD;EACnD,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA,6CAA6C;AAC7C;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA,+CAA+C;AAC/C;;EAEE,2BAA2B;EAC3B,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,iCAAiC;EACjC,sBAAsB;EACtB,qDAAqD;EACrD,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,kCAAkC;AAClC;EACE,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA,kDAAkD;AAClD;EACE,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,uDAAuD;AACzD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,iCAAiC;EACjC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA,2CAA2C;AAC3C;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,uDAAuD;EACvD,4BAA4B;EAC5B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA,+CAA+C;AAC/C;EACE,0BAA0B;EAC1B,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,2BAA2B;EAC3B,6BAA6B;AAC/B;;AAEA;EACE,qDAAqD;EACrD,wDAAwD;EACxD,4BAA4B;EAC5B,8BAA8B;EAC9B,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,mDAAmD;AACrD;;AAEA,4CAA4C;AAC5C;EACE,kDAAkD;EAClD,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,yCAAyC;EACzC,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,wBAAwB;EACxB,8BAA8B;EAC9B,yCAAyC;AAC3C;;AAEA,kCAAkC;AAClC;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,yBAAyB;EACzB,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA,sCAAsC;AACtC;EACE,yBAAyB;AAC3B","sourcesContent":[".dashboard-container {\n  width: 100%;\n  display: flex;\n  gap: 24px;\n  height: calc(100vh - 165px);\n}\n\n/* Filters Section */\n.filters-section {\n  width: 280px;\n  min-width: 280px;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid rgba(27, 40, 94, 0.08);\n  overflow: hidden;\n  height: calc(100vh - 100px) !important;\n}\n\n.filters-title {\n  color: #1B285E;\n  font-family: \"Trasandina\", sans-serif;\n  font-size: 1rem;\n  font-weight: 500;\n  padding: 16px;\n  border-bottom: 1px solid rgba(27, 40, 94, 0.08);\n  background: white;\n  flex-shrink: 0;\n}\n\n.filter-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 16px;\n  background: white;\n  border-bottom: 1px solid rgba(27, 40, 94, 0.08);\n  flex-shrink: 0;\n}\n\n.filter-chip {\n  background: rgba(27, 40, 94, 0.05) !important;\n  color: #1B285E !important;\n  font-size: 0.813rem !important;\n  height: 28px !important;\n  border-radius: 14px !important;\n}\n\n.filter-chip .MuiChip-deleteIcon {\n  color: #1B285E !important;\n  font-size: 16px !important;\n  opacity: 0.5;\n}\n\n.filter-chip .MuiChip-deleteIcon:hover {\n  opacity: 1;\n}\n\n.filter-section {\n  padding: 16px;\n  position: relative;\n  border-bottom: 1px solid transparent;\n}\n\n.filter-section.has-selected {\n  border-bottom: 1px solid rgba(27, 40, 94, 0.08);\n}\n\n.filter-section.has-selected::before {\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 16px;\n  bottom: 16px;\n  width: 3px;\n  background: #1B285E;\n  border-radius: 0 2px 2px 0;\n}\n\n.filter-label {\n  color: #1B285E;\n  font-size: 0.875rem;\n  font-weight: 600;\n  margin-bottom: 12px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.filter-options {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.filter-option {\n  background: transparent !important;\n  border: none !important;\n  color: rgba(27, 40, 94, 0.7) !important;\n  padding: 4px 8px !important;\n  margin-left: -8px !important;\n  border-radius: 0 !important;\n  font-size: 0.875rem !important;\n  min-width: unset !important;\n  text-transform: none !important;\n  transition: all 0.2s ease !important;\n  text-align: left !important;\n  justify-content: flex-start !important;\n  position: relative !important;\n  width: fit-content !important;\n}\n\n.filter-option::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 8px;\n  right: 8px;\n  height: 2px;\n  background-color: #1B285E;\n  transform: scaleX(0);\n  transition: transform 0.2s ease;\n}\n\n.filter-option:hover {\n  background: rgba(27, 40, 94, 0.03) !important;\n  color: #1B285E !important;\n}\n\n.filter-option:hover::after {\n  transform: scaleX(0.3);\n}\n\n.filter-option.selected {\n  background: transparent !important;\n  color: #1B285E !important;\n  font-weight: 600 !important;\n}\n\n.filter-option.selected::after {\n  transform: scaleX(1);\n}\n\n.filter-switch {\n  margin: 0 !important;\n}\n\n.filter-input {\n  width: 100% !important;\n}\n\n.filter-input .MuiOutlinedInput-root {\n  border-radius: 4px !important;\n}\n\n/* Content Section */\n.content-section {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  background: white;\n  border-radius: 8px;\n  border: 1px solid rgba(27, 40, 94, 0.08);\n  overflow: hidden;\n}\n\n.content-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 0;\n  flex-shrink: 0;\n  padding: 16px;\n  border-bottom: 1px solid rgba(27, 40, 94, 0.08);\n  background: white;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n.dashboard-title {\n  color: #1B285E;\n  font-family: \"Trasandina\", sans-serif;\n  font-size: 1.25rem;\n  margin: 0;\n}\n\n.results-count {\n  color: rgba(27, 40, 94, 0.7);\n  font-size: 0.875rem;\n}\n\n.export-buttons {\n  display: flex;\n  gap: 8px;\n}\n\n/* Scrollable container for both filters and table */\n.scrollable-content {\n  flex: 1;\n  overflow: auto;\n  min-height: 0;\n  position: relative;\n  overflow-x: auto !important;\n  overflow-y: auto !important;\n  height: calc(100vh - 200px) !important;\n}\n\n/* Table Styles */\n.dashboard-table-container {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n.dashboard-table {\n  width: 100%;\n}\n\n.table-header-row {\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 1 !important;\n  background: white !important;\n}\n\n.dashboard-table-header {\n  padding: 6px 8px !important;\n  font-size: 0.8rem !important;\n  font-weight: 600 !important;\n  white-space: nowrap !important;\n  text-overflow: ellipsis !important;\n  overflow: hidden !important;\n  background-color: #1B285E !important;\n  color: white !important;\n  position: sticky !important;\n  top: 0 !important;\n  z-index: 2 !important;\n}\n\n/* Fixed height for table rows */\n.table-row {\n  height: 48px !important; /* Fixed height for all rows */\n}\n\n.dashboard-table-cell {\n  padding: 6px 8px !important;\n  font-size: 0.8rem !important;\n  white-space: nowrap !important;\n  text-overflow: ellipsis !important;\n  overflow: hidden !important;\n  max-width: 150px !important;\n  color: #1B285E !important;\n  border-bottom: 1px solid rgba(27, 40, 94, 0.05) !important;\n  background: white !important;\n  transition: opacity 0.3s ease !important;\n  line-height: 1.2 !important; /* Consistent line height */\n  height: 48px !important; /* Match the row height */\n  box-sizing: border-box !important;\n}\n\n.table-row:hover .dashboard-table-cell {\n  background-color: rgba(27, 40, 94, 0.02) !important;\n}\n\n.table-loading {\n  position: relative;\n}\n\n.table-loading::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.7);\n  z-index: 2;\n  pointer-events: none;\n}\n\n.table-loading-spinner {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 3;\n}\n\n/* Custom scrollbar */\n.scrollable-content::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.scrollable-content::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb {\n  background: rgba(27, 40, 94, 0.2);\n  border-radius: 4px;\n}\n\n.scrollable-content::-webkit-scrollbar-thumb:hover {\n  background: rgba(27, 40, 94, 0.3);\n}\n\n/* Pagination */\n.MuiTablePagination-root {\n  flex-shrink: 0;\n  border-top: 1px solid rgba(27, 40, 94, 0.08);\n  background: white;\n}\n\n/* Responsive Design */\n@media (max-width: 960px) {\n  .dashboard-container {\n    flex-direction: column;\n    height: auto;\n    gap: 16px;\n  }\n\n  .filters-section {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .filter-options {\n    flex-direction: row;\n    flex-wrap: wrap;\n    gap: 8px;\n  }\n\n  .filter-option {\n    padding: 4px 12px !important;\n    background: rgba(27, 40, 94, 0.05) !important;\n    border-radius: 16px !important;\n  }\n\n  .content-section {\n    height: calc(100vh - 400px);\n  }\n}\n\n@media (max-width: 600px) {\n  .content-header {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 12px;\n  }\n\n  .export-buttons {\n    width: 100%;\n  }\n\n  .export-buttons button {\n    flex: 1;\n  }\n}\n\n/* Estilos para los iconos de paginación */\n.MuiTablePagination-actions {\n  color: #1B285E !important; /* Usa el mismo color azul que el resto de la UI */\n}\n\n.MuiTablePagination-actions button {\n  color: rgba(27, 40, 94, 0.7) !important; /* Color más suave para los botones */\n}\n\n.MuiTablePagination-actions button:hover {\n  color: #1B285E !important; /* Color más oscuro al hover */\n}\n\n.MuiTablePagination-actions button.Mui-disabled {\n  color: rgba(27, 40, 94, 0.3) !important; /* Color más claro para botones deshabilitados */\n}\n\n/* Estilos para el modo edición */\n.actions-cell {\n  width: 100px;\n  text-align: right !important;\n}\n\n.edit-button {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}\n\n.table-row:hover .edit-button {\n  opacity: 1;\n}\n\n/* Estilos para los campos de edición */\n.dashboard-table-cell .MuiTextField-root {\n  margin: -8px 0;\n}\n\n.dashboard-table-cell .MuiCheckbox-root {\n  margin: -12px;\n}\n\n/* Apollo processed row styling */\n.apollo-processed-row.table-row {\n  background-color: rgba(144, 202, 249, 0.15) !important;\n}\n\n.apollo-processed-row.table-row:hover {\n  background-color: rgba(144, 202, 249, 0.25) !important;\n}\n\n/* Add a CSS class for the profile photo column */\n.profile-photo-cell {\n  width: 40px !important;\n  padding: 4px !important;\n}\n\n/* Make the table container take full width */\n.MuiTableContainer-root {\n  width: 100% !important;\n}\n\n/* Add responsive styling for smaller screens */\n@media (max-width: 1200px) {\n  .dashboard-table-header, \n  .dashboard-table-cell {\n    padding: 4px 6px !important;\n    font-size: 0.75rem !important;\n  }\n}\n\n/* Add styles for email status chips */\n.email-status-chip.verified {\n  background-color: rgba(46, 125, 50, 0.1) !important;\n  color: #2e7d32 !important;\n  border-color: #2e7d32 !important;\n}\n\n.email-status-chip.extrapolated {\n  background-color: rgba(237, 108, 2, 0.1) !important;\n  color: #ed6c02 !important;\n  border-color: #ed6c02 !important;\n}\n\n.email-status-chip.unavailable {\n  background-color: rgba(211, 47, 47, 0.1) !important;\n  color: #d32f2f !important;\n  border-color: #d32f2f !important;\n}\n\n/* Style for the employment history tooltip */\n.employment-history-tooltip {\n  max-width: 500px !important;\n  font-size: 0.8rem !important;\n}\n\n/* Enhanced employment history tooltip styles */\n.employment-history-tooltip,\n.MuiTooltip-tooltip .employment-history-tooltip {\n  max-width: 500px !important;\n  font-size: 0.9rem !important;\n  line-height: 1.5 !important;\n  padding: 12px !important;\n  background-color: #fff !important;\n  color: #000 !important;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15) !important;\n  border-radius: 8px !important;\n  border: 1px solid rgba(27, 40, 94, 0.1) !important;\n}\n\n.employment-history-tooltip strong {\n  color: #1B285E !important;\n  font-weight: 600 !important;\n}\n\n/* Style for the LinkedIn button */\n.linkedin-button {\n  min-width: unset !important;\n  padding: 2px 8px !important;\n}\n\n/* Add styles for the employment history stepper */\n.MuiStepper-root {\n  padding: 0 !important;\n}\n\n.MuiStepContent-root {\n  margin-left: 12px !important;\n  padding-left: 20px !important;\n  border-left: 1px solid rgba(27, 40, 94, 0.2) !important;\n}\n\n.MuiStepLabel-root {\n  padding: 0 !important;\n}\n\n.MuiStepLabel-labelContainer {\n  color: #1B285E !important;\n}\n\n.MuiStepConnector-line {\n  min-height: 24px !important;\n  border-left-width: 2px !important;\n  border-left-style: solid !important;\n  border-color: rgba(27, 40, 94, 0.2) !important;\n}\n\n/* Enhanced styles for employment history */\n.employment-history .MuiTypography-subtitle1 {\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  color: #1B285E !important;\n}\n\n.employment-history .MuiTypography-body2 {\n  font-size: 0.9rem !important;\n  color: #000 !important;\n  line-height: 1.5 !important;\n  margin-bottom: 6px !important;\n}\n\n.employment-history .MuiStepContent-root {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  border-left: 2px solid rgba(27, 40, 94, 0.3) !important;\n  padding: 8px 16px !important;\n  margin-bottom: 12px !important;\n  border-radius: 0 0 4px 4px !important;\n}\n\n.employment-history .MuiAvatar-root {\n  border: 2px solid #fff !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Same enhanced styles for education history */\n.education-history .MuiTypography-subtitle1 {\n  font-size: 1rem !important;\n  font-weight: 600 !important;\n  color: #1B285E !important;\n}\n\n.education-history .MuiTypography-body2 {\n  font-size: 0.9rem !important;\n  color: #000 !important;\n  line-height: 1.5 !important;\n  margin-bottom: 6px !important;\n}\n\n.education-history .MuiStepContent-root {\n  background-color: rgba(255, 255, 255, 0.8) !important;\n  border-left: 2px solid rgba(63, 81, 181, 0.3) !important;\n  padding: 8px 16px !important;\n  margin-bottom: 12px !important;\n  border-radius: 0 0 4px 4px !important;\n}\n\n.education-history .MuiAvatar-root {\n  border: 2px solid #fff !important;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1) !important;\n}\n\n/* Custom styles for current job indicator */\n.current-job-chip {\n  background-color: rgba(27, 40, 94, 0.1) !important;\n  color: #1B285E !important;\n  font-weight: 500 !important;\n}\n\n/* Add styles for Apollo processed indicators */\n.apollo-data-section {\n  margin-bottom: 24px;\n  padding: 16px;\n  background-color: rgba(255, 255, 255, 0.95);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n  position: relative;\n}\n\n.apollo-data-section h3 {\n  margin-top: 0;\n  margin-bottom: 16px;\n  color: #1B285E;\n  font-weight: 600;\n  font-size: 1.2rem;\n  border-bottom: 2px solid rgba(27, 40, 94, 0.1);\n  padding-bottom: 8px;\n}\n\n.apollo-data-section .MuiListItem-root {\n  border-radius: 4px;\n  transition: background-color 0.2s ease;\n}\n\n.apollo-data-section .MuiListItem-root:hover {\n  background-color: rgba(144, 202, 249, 0.1);\n}\n\n.apollo-data-badge {\n  position: absolute;\n  top: -10px;\n  right: 16px;\n  background-color: rgba(25, 118, 210, 0.9);\n  color: white;\n  font-size: 0.7rem;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n/* Enhanced drawer styles for better readability */\n.drawer-content {\n  padding: 20px 16px;\n  overflow-y: auto;\n  height: 100%;\n  background-color: #f9f9f9;\n}\n\n.drawer-header {\n  background-color: #fff;\n  border-radius: 8px;\n  padding: 16px !important;\n  margin-bottom: 24px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);\n}\n\n/* Make list items more readable */\n.drawer-content .MuiListItem-root {\n  padding: 10px 0;\n  margin-bottom: 4px;\n}\n\n.drawer-content .MuiListItemIcon-root {\n  color: #1B285E;\n  min-width: 36px !important;\n}\n\n.drawer-content .MuiListItemText-root .MuiTypography-root {\n  font-size: 0.95rem;\n  color: rgba(0, 0, 0, 0.87);\n  font-weight: 500;\n}\n\n.drawer-content strong {\n  font-weight: 600;\n  color: #1B285E;\n}\n\n.drawer-content a {\n  color: #1976d2;\n  text-decoration: none;\n  font-weight: 500;\n}\n\n.drawer-content a:hover {\n  text-decoration: underline;\n  color: #1565c0;\n}\n\n/* Divider styling */\n.drawer-content .MuiDivider-root {\n  margin: 16px 0 !important;\n  background-color: rgba(27, 40, 94, 0.1);\n  height: 2px !important;\n}\n\n.dashboard-table-cell .MuiBox-root {\n  display: flex !important;\n  align-items: center !important;\n  height: 100% !important;\n}\n\n/* Ensure icons are aligned properly */\n.dashboard-table-cell .MuiSvgIcon-root {\n  flex-shrink: 0 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
